/** @format */

import { takeLatest, put, all, call } from 'redux-saga/effects';
import { socket } from '../../utils/socketIo';
import axios from 'axios';
import {
  auth,
  googleProvider,
  microsoftProvider,
  getCurrentUser,
} from '../../firebase/firebase.utils';
import UserActionTypes from './user.types';
import {
  signInSuccess,
  signInFaliure,
  signOutSuccess,
  signOutFailure,
} from './user.actions';

import { flightDataReset } from '../flightData/flightData.actions';

import { customerDataReset } from '../customers/customer.actions';

export function* signIn() {
  try {
    const { user } = yield auth.signInWithPopup(microsoftProvider);

    const domainAuthorization = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/auth/login',
      method: 'post',
      data: { userAuth: user },
    });
    if (domainAuthorization.data.authorized) {
      yield put(
        signInSuccess({ user: user, role: domainAuthorization.data.role })
      );
      yield socket.connect();
    } else {
      yield put(signInSuccess({ user: null, role: null }));
    }
  } catch (error) {
    yield alert('Not Authorized!');
    yield put(signInFaliure(error));
  }
}

export function* signInWithMicrosoft() {
  try {
    const { user } = yield auth.signInWithPopup(microsoftProvider);
    const domainAuthorization = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/auth/login',
      method: 'post',
      data: { userAuth: user },
    });
    if (domainAuthorization.data.authorized) {
      yield put(
        signInSuccess({ user: user, role: domainAuthorization.data.role })
      );
      yield socket.connect();
    } else {
      yield put(signInSuccess({ user: null, role: null }));
    }
  } catch (error) {
    yield alert('Not Authorized!');
    yield put(signInFaliure(error));
  }
}

export function* isUserAuthenticated() {
  try {
    const userAuth = yield getCurrentUser();
    if (userAuth === null) return;
    const { user } = userAuth.multiFactor;

    const domainAuthorization = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/auth/login',
      method: 'post',
      data: { userAuth: user },
    });
    if (domainAuthorization.data.authorized) {
      yield put(
        signInSuccess({ user: user, role: domainAuthorization.data.role })
      );
      yield socket.connect();
    } else {
      yield put(signInSuccess({ user: null, role: null }));
    }
  } catch (error) {
    yield put(signInFaliure(error));
  }
}

export function* signOut() {
  try {
    const userAuth = yield getCurrentUser();
    yield auth.signOut();
    const { user } = userAuth.multiFactor;

    yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/auth/logout',
      method: 'post',
      data: { userAuth: user },
    });
    // Delete Flight Data
    yield put(flightDataReset());
    // Delete Customer Data
    yield put(customerDataReset());
    yield put(signOutSuccess());
    yield socket.disconnect();
  } catch (error) {
    yield put(signOutFailure(error));
  }
}

export function* onCheckUserSession() {
  yield takeLatest(UserActionTypes.CHECK_USER_SESSION, isUserAuthenticated);
}

export function* onSignInStart() {
  yield takeLatest(UserActionTypes.SIGN_IN_START, signIn);
}

export function* onMicrosoftSignInStart() {
  yield takeLatest(
    UserActionTypes.MICROSOFT_SIGN_IN_START,
    signInWithMicrosoft
  );
}

export function* onSignOutStart() {
  yield takeLatest(UserActionTypes.SIGN_OUT_START, signOut);
}

export function* userSagas() {
  yield all([
    call(onSignInStart),
    call(onCheckUserSession),
    call(onSignOutStart),
    call(onMicrosoftSignInStart),
  ]);
}
